import MainIcons from '@/icons/main';
import React from 'react';
import styles from '../styles.module.css';
import PageCard from '@/components/general/PageCard';
import { useLayoutContext } from '@/context/LayoutContext';

export default function Guaranty({
  showTitle = true,
  headClass = '',
  className = '',
}: {
  showTitle?: boolean;
  headClass?: string;
  className?: string;
}) {
  const { guarantees } = useLayoutContext();

  return (
    <PageCard
      noIconWidth={true}
      title={showTitle ? 'تضمین خرید کارا' : null}
      headClass={headClass}
      className={className}
    >
      <div className={styles.list}>
        {guarantees?.map((item, index) => (
          <div key={index} className={styles.item}>
            <span className={`${styles.icon} `} style={{ backgroundColor: item?.bg }}>
              {item?.icon}
            </span>

            <span className={styles.itemTitle}>{item.title}</span>
          </div>
        ))}
      </div>
    </PageCard>
  );
}
